import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import moment from "moment";

class ConfirmOrder extends React.Component {
  handleConfirm = event => {
    event.preventDefault();
    this.context.router.history.push("/dashboard/orderhistory");
  };
  render() {
    const order = this.props.orderPayload;
    const transaction = order.paypal.transactions[0].amount;
    const useType = order.item.useType;
    let plan;
    if (useType === "USA") {
      plan = "US Plan";
    }
    if (useType === "GLOBAL") {
      plan = "Global Plan";
    }
    const after_discount_totals = order.after_discount_totals;
    let powerbank = false;
    if(typeof after_discount_totals !== "undefined" && after_discount_totals != null) {
      for (var i = 0; i < after_discount_totals.length; i++) {
        //console.log(after_discount_totals[i]);
        if (typeof after_discount_totals[i].prefix !== "undefined" && after_discount_totals[i].prefix === "powerbank") {
          powerbank = true;
        }
      }
    }
    const autoRenewal = order.autoRenewal;
    //const renewalStartDate = moment(order.cart.startDate.substring(0, 10)).add(order.cart.recurring_profile.period, "days").format("MM/DD/YYYY");
    const nextRechargeDate = moment(order.cart.startDate.substring(0, 10)).add(order.cart.recurring_profile.period - 1, "days").format("MM/DD/YYYY");

    console.log("props", this.props);
    return (
      <div className="col-md-8 services_clip">
        <div className="">
          <div className="row">
            <div className="col-lg-12">
              <div className="services_boxes">
                <div className="services_content">

                  {
                    (order.cart.cartType == "device_recharge") ? (
                        <h3 className="mb-0">Your Device has been successfully recharged for { order.cart.recurring_profile.period } additional {order.cart.recurring_profile.period_unit.toLowerCase()}.</h3>
                    ) : (
                        <h3 className="mb-0">Your SIM has been successfully recharged for { order.product.recurringPeriod } additional days.</h3>
                    )
                  }

                  { autoRenewal ?
                    (
                        <div>
                          <div style={{ clear: "both", height: "20px" }} />
                          <div>
                            <h4 className="mb-0">AUTO PAY is active.</h4>
                            <h4 className="mb-0">Next recharge date: {nextRechargeDate}</h4>
                          </div>
                        </div>
                    ) : null
                  }

                  <div style={{ clear: "both", height: "20px" }} />

                  <div className="row">
                    <div className="col-lg-12">
                      <p className="mb-0 mt-2">Date : <span className="bold600">
                        {moment(order.orderDate).format(
                            "MM/DD/YYYY"
                        )}
                      </span></p>
                      <p className="mb-0 mt-2">
                        Order Number:{" "}
                        <span className="bold600">
                        <Link
                            to={`/dashboard/order/${
                                order.orderId
                            }`}
                          >
                            {order.orderId}
                          </Link>
                        </span>
                      </p>
                      <p className="mb-0 mt-2">Country : <span className="bold600">{(order.cart.useType === "GLOBAL" && typeof order.cart.country !== "undefined" && order.cart.country !== null) ? order.cart.country.name : order.cart.useType}</span></p>
                      <p className="mb-0 mt-2">Product: <strong>{order.product.name}</strong></p>

                      {
                        (order.cart.cartType == "device_recharge") ? (
                            <p className="mb-0 mt-2">
                            Data Plan:{" "}
                              <strong>{order.cart.recurring_profile.name}</strong>
                            </p>
                        ) : (
                            <p className="mb-0 mt-2">{order.product.shortDescription}</p>
                        )
                      }

                      {
                        (powerbank) ? (
                            <p className="mb-0 mt-2">Powerbank 1 EA included</p>
                        ) : null
                      }


                      {
                        (order.cart.cartType == "device_recharge") ? (
                          <p>
                            {/*<p className="mb-0 mt-2">Your Device being recharged.</p>*/}
                            <p className="mb-0 mt-2">IMEI : <strong>{order.cart.imei}</strong></p>
                          </p>
                            ) : (
                          <p className="mb-0 mt-2">
                            <strong>{order.phone_no}</strong> being recharged.
                          </p>
                            )
                      }

                      {
                        (order.cart.startDate !== null) ? (
                            <p className="mb-0 mt-2">
                            Start Date:{" "}
                              <strong>
                                {moment(order.cart.startDate.substring(0, 10)).format(
                                    "MM/DD/YYYY"
                                )}
                              </strong>
                            </p>

                        ) : null
                      }

                      {
                        /*(order.cart.endDate !== null) ? (
                            <p className="mb-0 mt-2">
                              End Date:{" "}
                              <strong>
                                {moment(order.cart.endDate.substring(0, 10)).format(
                                    "MM/DD/YYYY"
                                )}
                              </strong>
                            </p>

                        ) : null*/
                        (order.cart.startDate !== null) ? (
                            <p className="mb-0 mt-2">
                              End Date:{" "}
                              <strong>
                                {moment(order.cart.startDate.substring(0, 10)).add(order.cart.recurring_profile.period - 1, "days").format(
                                    "MM/DD/YYYY"
                                )}
                              </strong>
                            </p>

                        ) : null
                      }

                      { order.cart.cartType === 'recharge' ?
                          (
                              <p className="mb-0 mt-2">
                                Recharge price: {" "}
                                <strong>
                                  {!parseFloat(order.subtotal) ? null : "$" } {!parseFloat(order.subtotal) ? "0.00" : parseFloat(order.subtotal).toFixed(2) }
                                </strong>
                                <br/>
                                Tax: {" "}
                                <strong>
                                  {!parseFloat(order.tax) ? null : "$" } {!parseFloat(order.tax) ? "Included" : parseFloat(order.tax).toFixed(2) }
                                </strong>
                                <br/>
                              </p>
                        ) : null
                      }

                      <p className="mb-0 mt-2">
                        Sub Total: {" "}
                        {
                          (typeof order.after_discount_totals_flat !== "undefined" && order.after_discount_totals_flat !== null && typeof order.after_discount_totals_flat.grandTotal !== "undefined" && order.after_discount_totals_flat !== null && order.after_discount_totals_flat.discount > 0) ? (
                                    <span>
                                        <strong className="discount-price">
                                          ${parseFloat(order.after_discount_totals_flat.grandTotal).toFixed(2)}
                                        </strong>&nbsp;
                                        <span className="bold600 discount">
                                          ${parseFloat(order.subtotal).toFixed(2)}
                                        </span>
                                    </span>
                              ):
                                    <strong>
                                      ${parseFloat(order.subtotal).toFixed(2)}
                                    </strong>
                        }
                        </p>
                        { order.item.cartType !== 'device_recharge' ?
                            (
                                <p className="mb-0 mt-2">
                                Shipping Fee: {" "}
                                  <strong>
                                  {!order.shippingFee ? "Free" : "$" + parseFloat(order.shippingFee).toFixed(2)}
                                  </strong>
                                </p>
                            ) : null
                        }
                        <p className="mb-0 mt-2">Tax: <strong>{!parseFloat(order.tax) ? "Included" : "$" + parseFloat(order.tax).toFixed(2) }</strong></p>
                        <p className="mb-0 mt-2">Total: <strong>${parseFloat(transaction.total).toFixed(2)}</strong></p>
                    </div>
                  </div>

                  <div style={{ clear: "both", height: "30px" }} />

                  <a
                    href="javascript:void(0)"
                    onClick={this.handleConfirm}
                    className="btn btn-orange"
                  >
                    MY ACCOUNT
                  </a>

                  <div style={{ clear: "both", height: "100px" }} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
ConfirmOrder.contextTypes = {
  router: PropTypes.object.isRequired
};

export default ConfirmOrder;



// WEBPACK FOOTER //
// ./src/pages/eSimCheckout/ConfirmOrder.js